import { Card, DatePicker, FormInstance, Input, InputNumber, Row } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React from 'react';

import FormInput from 'components/FormInput';
import GetLabel from 'DisplayFramework/components/GetLabel';
import UtinaCard from 'components/UtinaCard';
import Address from 'components/address';
import ParListSelect from 'components/ParListSelect';
import { useQuery } from 'react-query';
import { getAssetattributeByCriteria } from 'services/assetconfig';
import { OnlyIntegerNumber } from 'utils/utils2';
type AssetExtraInfoProps = {
  form: FormInstance;
  state?: any;
  tab?:boolean
};
const AssetExtraInfo = (props: AssetExtraInfoProps) => {
  const { form, state,tab } = props;

  const { data, refetch, isFetching } = useQuery(
    [
      'getAssetattributeByCriteria',
      {
        attid: 0,
        assetfamily: state.assetfamily?.value,
        assettype: state.assettype?.value,
        assetcategory: state.assetcategory?.value,
      },
    ],
    () =>
      getAssetattributeByCriteria({
        attid: 0,
        assetfamily: state.assetfamily.value ?? '',
        assettype: state.assettype?.value ?? '',
        assetcategory: state.assetcategory?.value ?? '',
      }).then((res) => res.list),
    { enabled: !!state.assetfamily }
  );

  return (
    <Card title={!tab&&<GetLabel label="assetAdditionalInfo" style={{fontWeight:'bold',paddingLeft:15}}/>} style={tab?{borderColor:'transparent',}:{}}>
      <Row gutter={8}>
        <UtinaCard
          level={5}
          comcode="technical-characteristics"
          style={{ color: '#000', marginLeft: 30 }}
          lg={15}
          additionalAttribute
        >
          {data &&
            (data[0]?.age === 'DISPLAY' || data[0]?.age === 'MANDATORY') && (
              <FormInput
                rules={[{ required: data[0]?.age === 'MANDATORY' }]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="age"
                normalize={OnlyIntegerNumber}
                style={{padding:'0px !important'}}
              >
                <Input maxLength={4} />
              </FormInput>
            )}
          {data &&
            (data[0]?.balersize === 'DISPLAY' ||
              data[0]?.balersize === 'MANDATORY') && (
              <FormInput
                rules={[{ required: data[0]?.balersize === 'MANDATORY' }]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="balersize"
              >
                <ParListSelect parcode="BALERSIZE" />
              </FormInput>
            )}
          {data &&
            (data[0]?.separatortype === 'DISPLAY' ||
              data[0]?.separatortype === 'MANDATORY') && (
              <FormInput
                rules={[{ required: data[0]?.separatortype === 'MANDATORY' }]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="separatortype"
              >
                <ParListSelect parcode="SEPTYPE" />
              </FormInput>
            )}

          {data &&
            (data[0]?.wheeldrive === 'DISPLAY' ||
              data[0]?.wheeldrive === 'MANDATORY') && (
              <FormInput
                rules={[{ required: data[0]?.wheeldrive === 'MANDATORY' }]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="wheeldrive"
              >
                <ParListSelect parcode="WHEELDRIVE" />
              </FormInput>
            )}

          {data &&
            (data[0]?.transmission === 'DISPLAY' ||
              data[0]?.transmission === 'MANDATORY') && (
              <FormInput
                rules={[{ required: data[0]?.transmission === 'MANDATORY' }]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="transmission"
              >
                <ParListSelect parcode="TRANSMIS" />
              </FormInput>
            )}

          {data &&
            (data[0]?.wheeltrack === 'DISPLAY' ||
              data[0]?.wheeltrack === 'MANDATORY') && (
              <FormInput
                rules={[{ required: data[0]?.wheeltrack === 'MANDATORY' }]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="wheeltrack"
              >
                <Input maxLength={10} />
              </FormInput>
            )}

          {data &&
            (data[0]?.lift === 'DISPLAY' || data[0]?.lift === 'MANDATORY') && (
              <FormInput
                rules={[{ required: data[0]?.lift === 'MANDATORY' }]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="lift"
              >
                <InputNumber type="number" min={0} />
              </FormInput>
            )}

          {data &&
            (data[0]?.capacity === 'DISPLAY' ||
              data[0]?.capacity === 'MANDATORY') && (
              <FormInput
                rules={[
                  { required: data[0]?.capacity === 'MANDATORY', message: '' },
                ]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="capacity"
              >
                <InputNumber type="number" min={0} />
              </FormInput>
            )}

          {data &&
            (data[0]?.tankcapacity === 'DISPLAY' ||
              data[0]?.tankcapacity === 'MANDATORY') && (
              <FormInput
                rules={[{ required: data[0]?.tankcapacity === 'MANDATORY' }]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="tankcapacity"
              >
                <InputNumber type="number" min={0} />
              </FormInput>
            )}

          {data &&
            (data[0]?.nbcampaign === 'DISPLAY' ||
              data[0]?.nbcampaign === 'MANDATORY') && (
              <FormInput
                rules={[{ required: data[0]?.nbcampaign === 'MANDATORY' }]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="nbcampaign"
                normalize={OnlyIntegerNumber}
              >
                <Input />
              </FormInput>
            )}

          {data &&
            (data[0]?.threshinghours === 'DISPLAY' ||
              data[0]?.threshinghours === 'MANDATORY') && (
              <FormInput
                rules={[{ required: data[0]?.threshinghours === 'MANDATORY' }]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="threshinghours"
                normalize={OnlyIntegerNumber}
              >
                <Input />
              </FormInput>
            )}

          {data &&
            (data[0]?.rotorhours === 'DISPLAY' ||
              data[0]?.rotorhours === 'MANDATORY') && (
              <FormInput
                rules={[{ required: data[0]?.rotorhours === 'MANDATORY' }]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="rotorhours"
                normalize={OnlyIntegerNumber}
              >
                <Input />
              </FormInput>
            )}

          {data &&
            (data[0]?.totalbalers === 'DISPLAY' ||
              data[0]?.totalbalers === 'MANDATORY') && (
              <FormInput
                rules={[{ required: data[0]?.totalbalers === 'MANDATORY' }]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="totalbalers"
                normalize={OnlyIntegerNumber}
              >
                <Input />
              </FormInput>
            )}
          {data &&
            (data[0]?.country === 'DISPLAY' ||
              data[0]?.country === 'MANDATORY') && (
              <FormInput
                rules={[{ required: data[0]?.country === 'MANDATORY' }]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="country"
              >
                <ParListSelect parcode="COUNTRY" />
              </FormInput>
            )}

          {data &&
            (data[0]?.kwhpower === 'DISPLAY' ||
              data[0]?.kwhpower === 'MANDATORY') && (
              <FormInput
                rules={[{ required: data[0]?.kwhpower === 'MANDATORY' }]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="kwhpower"
              >
                <InputNumber min={0} />
              </FormInput>
            )}

          {data &&
            (data[0]?.kwhproduction === 'DISPLAY' ||
              data[0]?.kwhproduction === 'MANDATORY') && (
              <FormInput
                rules={[{ required: data[0]?.kwhproduction === 'MANDATORY' }]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="kwhproduction"
              >
                <InputNumber min={0} />
              </FormInput>
            )}

          {data &&
            (data[0]?.kwhdegradation === 'DISPLAY' ||
              data[0]?.kwhdegradation === 'MANDATORY') && (
              <FormInput
                rules={[{ required: data[0]?.kwhdegradation === 'MANDATORY' }]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="kwhdegradation"
              >
                <InputNumber min={0} />
              </FormInput>
            )}

          {data &&
            (data[0]?.power === 'DISPLAY' ||
              data[0]?.power === 'MANDATORY') && (
              <>
                <FormInput
                  rules={[{ required: data[0]?.power === 'MANDATORY' }]}
                  col
                  xs={24}
                  md={6}
                  labelCol={{ span: 24 }}
                  name="power"
                >
                  <Input max={10} />
                </FormInput>
                <FormInput
                  col
                  xs={24}
                  md={6}
                  labelCol={{ span: 24 }}
                  name="fiscalpower"
                  rules={[{ required: false }]}
                >
                  <Input />
                </FormInput>
              </>
            )}

          {data &&
            (data[0]?.engineno === 'DISPLAY' ||
              data[0]?.engineno === 'MANDATORY') && (
              <FormInput
                rules={[{ required: data[0]?.engineno === 'MANDATORY' }]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="engineno"
              >
                <Input max={100} />
              </FormInput>
            )}

          {data &&
            (data[0]?.weight === 'DISPLAY' ||
              data[0]?.weight === 'MANDATORY') && (
              <FormInput
                rules={[{ required: data[0]?.weight === 'MANDATORY' }]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="weight"
              >
                <Input max={10} />
              </FormInput>
            )}

          {data &&
            (data[0]?.chassisno === 'DISPLAY' ||
              data[0]?.chassisno === 'MANDATORY') && (
              <FormInput
                rules={[{ required: data[0]?.chassisno === 'MANDATORY' }]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="chassisno"
              >
                <Input max={100} />
              </FormInput>
            )}

          {data &&
            (data[0]?.plateno === 'DISPLAY' ||
              data[0]?.plateno === 'MANDATORY') && (
              <FormInput
                rules={[{ required: data[0]?.plateno === 'MANDATORY' }]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="plateno"
              >
                <Input max={100} />
              </FormInput>
            )}

          {data &&
            (data[0]?.registrationno === 'DISPLAY' ||
              data[0]?.registrationno === 'MANDATORY') && (
              <>
                <FormInput
                  rules={[
                    { required: data[0]?.registrationno === 'MANDATORY' },
                  ]}
                  col
                  xs={24}
                  md={6}
                  labelCol={{ span: 24 }}
                  name="registrationno"
                >
                  <Input max={100} />
                </FormInput>
                <FormInput
                  col
                  xs={24}
                  md={6}
                  labelCol={{ span: 24 }}
                  name="registrationdate"
                  rules={[{ required: false }]}
                >
                  <DatePicker />
                </FormInput>
                <FormInput
                  col
                  xs={24}
                  md={6}
                  labelCol={{ span: 24 }}
                  name="registrationcity"
                  rules={[{ required: false }]}
                >
                  <Input />
                </FormInput>

                <FormInput
                  col
                  xs={24}
                  md={6}
                  labelCol={{ span: 24 }}
                  name="registrationname"
                  rules={[{ required: false }]}
                >
                  <Input />
                </FormInput>
                <FormInput
                  col
                  xs={24}
                  md={6}
                  labelCol={{ span: 24 }}
                  name="firstregistrationdate"
                  rules={[{ required: false }]}
                >
                  <DatePicker />
                </FormInput>
              </>
            )}

          {data &&
            (data[0]?.assetmodel === 'DISPLAY' ||
              data[0]?.assetmodel === 'MANDATORY') && (
              <FormInput
                rules={[{ required: data[0]?.assetmodel === 'MANDATORY' }]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="assetmodel"
              >
                <Input max={100} />
              </FormInput>
            )}

          {data &&
            (data[0]?.assetconstructor === 'DISPLAY' ||
              data[0]?.assetconstructor === 'MANDATORY') && (
              <FormInput
                rules={[
                  { required: data[0]?.assetconstructor === 'MANDATORY' },
                ]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="assetconstructor"
              >
                <Input max={100} />
              </FormInput>
            )}

          {data &&
            (data[0]?.serialno === 'DISPLAY' ||
              data[0]?.serialno === 'MANDATORY') && (
              <FormInput
                rules={[{ required: data[0]?.serialno === 'MANDATORY' }]}
                col
                xs={24}
                md={6}
                labelCol={{ span: 24 }}
                name="serialno"
              >
                <Input max={100} />
              </FormInput>
            )}

          <FormInput col xs={24} name="assetdescription">
            <TextArea rows={3} maxLength={500} />
          </FormInput>
        </UtinaCard>

        <UtinaCard
          level={5}
          comcode="delivery-address"
          style={{ color: '#000', marginLeft: 30 }}
          lg={8}
          additionalAttribute
        >
          <FormInput col xs={24} md={24} style={{marginBottom:'30px'}} name="deliveryadrstreet1" labelCol={(localStorage.getItem('lancode')==='FR')?{ span: 10 }:{span:4}}/>
          <FormInput col xs={24} md={24} style={{marginBottom:'30px',}} name="deliveryadrstreet2" labelCol={(localStorage.getItem('lancode')==='FR')?{ span: 10 }:{span:4}}/>
          <Address
            form={form}
            codePostalField="deliveryadrzipcode"
            paysField="deliveryadrcountry"
            regionField="deliveryadrregion"
            villeField="deliveryadrcity"
            colU={24}
            hideRegionGlobal
            Colw={(localStorage.getItem('lancode')==='FR')?{ span: 10 }:{span:4}}
            styles={{marginBottom:'30px',}}
          />
          
        </UtinaCard>
      </Row>
    </Card>
  );
};

export default AssetExtraInfo;
